module.exports = __webpack_public_path__ + "img/3484-03.03fea569.png";